module.exports = __webpack_public_path__ + "img/bg-4.982244a8.png";